const SectionLegend = ({ children, optional = false, action = null, description = '' }) => (
  <div className="mb-5">
    <div className="flex items-center gap-3">
      <span className="text-xs font-semibold uppercase tracking-wider text-base-content/50 whitespace-nowrap">
        {children}
      </span>
      <span className="flex-1 h-px bg-base-200" />
      {optional && (
        <span className="text-xs font-normal normal-case tracking-normal text-base-content/40 whitespace-nowrap">
          Optional
        </span>
      )}
      {action && action}
    </div>

    {description && <p className="mt-2 text-sm text-base-content/30">{description}</p>}
  </div>
);

export default SectionLegend;
